import { UserRole } from 'service/apicataleg/types/ApiCatalegTypes';
import { AuthenticationSliceState } from 'store/AuthenticationSlice';
import { useAppSelector } from 'store/Store';

const useRole = (): UserRole => {
  const auth: AuthenticationSliceState = useAppSelector((state) => state.auth);
  return auth.user?.role || 'client';
};

export default useRole;
